const translationEnglish = {
  nav: {
    notice: 'お知らせ',
    worldview: '世界観',
    stella: 'STELLA',
    media: 'メディア',
    webtoon: 'ウェブトゥーン',
  },
  news: {
    title: 'お知らせ',
    newest: '最新情報',
    more: '一覧を見る',
  },
  worldview: {
    title: '世界観',
  },
  stella: {
    title: 'STELLA',
  }, 
  media: {
    title: 'メディア'
  },
  stellaSection: {
    yato: {
      name: 'ヤト',
      description1: 'こんにちは、ヤトです！',
      description2: 'ヤトですよ～！', 
    },
    odanming: {
      name: 'オダンミン',
      description1: '愛の妖精、',
      description2: 'オダンミンです♡', 
    },
    hamkubby: {
      name: 'ハムクビ',
      description1: 'ハムクビで～す！',
      description2: 'えっ！？ これ、本当ですか！？', 
    },
    yune: {
      name: '網羽 ゆね',
      description1: 'こんにちは！',
      description2: '私が、素敵な夢を届けます♪', 
    },
    dori: {
      name: '証幸子 どり',
      description1: '幸運を証明する、',
      description2: 'どり、参上～！', 
    },
    fuwa: {
      name: '白貂 ふわ',
      description1: 'みなさんのこと、',
      description2: '私が守ってあげます！', 
    },
    niu: {
      name: 'ニウ ニウ',
      description1: '私ほどクールな人、',
      description2: 'いるかな？', 
    },
  }
};

export default translationEnglish;
